SP.lang.Class.define("SP.sitekit.form.field.CheckboxGroup", {
	extend: "SP.sitekit.form.field.FieldGroup",

	init: function (el, options) {
		this._super.apply(this, arguments);
	}
});
